import React from 'react';
import { DIRECTORS } from '../data/directors';

function DirectorCard({ director, showRoles }) {
  const content = (
    <>
      <div className="director-card__photo">
        <img src={director.image} alt={director.name} />
      </div>
      <h4 className="director-card__name">{director.name}</h4>
      {showRoles && <p className="director-card__role">{director.role}</p>}
      {director.linkedin && (
        <span className="director-card__linkedin" aria-hidden="true">
          <i className="fa fa-linkedin" />
        </span>
      )}
    </>
  );

  if (director.linkedin) {
    return (
      <a
        className="director-card director-card--linked"
        href={director.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${director.name} on LinkedIn`}
        data-aos="fade-up"
      >
        {content}
      </a>
    );
  }

  return (
    <div className="director-card" data-aos="fade-up">
      {content}
    </div>
  );
}

export default function DirectorGrid({ showRoles = true }) {
  return (
    <div className="director-grid">
      {DIRECTORS.map((director) => (
        <DirectorCard key={director.name} director={director} showRoles={showRoles} />
      ))}
    </div>
  );
}
